import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of } from 'rxjs';

import { UserSettingsActions } from './user-settings.actions';
import { UserSettingsAPIService } from '../api/user-settings-api.service';

export const getUserSettings$ = createEffect(
  (actions$ = inject(Actions), userService = inject(UserSettingsAPIService)) =>
    actions$.pipe(
      ofType(UserSettingsActions.getUserSettings),
      exhaustMap(() =>
        userService.read().pipe(
          map(userSettings => UserSettingsActions.getUserSettingsSuccess({ userSettings })),
          catchError(() => of(UserSettingsActions.getUserSettingsFailure({ error: 'Failed to load user settings' })))
        )
      )
    ),
  { functional: true }
);

export const saveUserSettings$ = createEffect(
  (actions$ = inject(Actions), userService = inject(UserSettingsAPIService)) =>
    actions$.pipe(
      ofType(UserSettingsActions.saveUserSettings),
      exhaustMap(({ settings }) =>
        userService.update(settings).pipe(
          map(userSettings => UserSettingsActions.saveUserSettingsSuccess({ userSettings })),
          catchError(() => of(UserSettingsActions.saveUserSettingsFailure({ error: 'Failed to save user settings' })))
        )
      )
    ),
  { functional: true }
);
